import logo from './logo.svg';
import './App.css';
import MetricsPage from './MetricsPage.js'
import LoginPage from './LoginPage.js'
import RegistrationPage from './RegistrationPage.js'
import Pages from './Enums.js'
import React, { useState, useEffect } from 'react';
import LogsPage from './LogsPage';
import Button from 'react-bootstrap/Button';
import "@fontsource/oswald";
import {auth, signInWithGoogle} from './firebase.js'
import { getRedirectResult, GoogleAuthProvider } from "firebase/auth";
// state holds page
// have buttons that change the value of page
function toLogin(setPage) {
  setPage(Pages.LOGIN);
}
/*
function handleOAuth(setUser, setPage) {
  getRedirectResult(auth)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access Google APIs.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;

    // The signed-in user info.
    const user = result.user;
    setUser(user);
    // IdP data available using getAdditionalUserInfo(result)
    toLogs(setPage);
    // ...
  }).catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    // ...
  })
}*/

function toRegistration(setPage) {
  setPage(Pages.REGISTER);
}

function toMetrics(setPage) {
  setPage(Pages.METRICS);
}

function toLogs(setPage) {
  setPage(Pages.LOGS);
}

function SubmitLogin(setPage) {
  toLogs(setPage);
}

function Logout(setPage) {
  // add in functionality to actually logout
  toLogin(setPage);
}

function Register(setPage) {
  toLogin(setPage);
}

function handleLogout(setPage) {
  auth.signOut();
  toLogin(setPage);
}

// have some header that we can use for both pages with the logout?
function DriveWiseHeader(props) {
  return (
    <div className="App-header">
      <table className="header-table">
        <tbody>
          <tr>
            <td className="header-name">
                DriveWise
            </td>
            <td className="logout-button">
                <Button variant="secondary" type="submit" onClick={props.handleLogout}>Logout</Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

function App() {
  // const [page, setPage] = useState(Pages.LOGIN);
  const [page, setPage] = useState(Pages.LOGIN);
  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      setUser(user);
      toLogs(setPage);
    })
  }, [])

  console.log(user);
  console.log(page);
  // whenever we want to add a page, define it in the Pages enum in Enum.js
  if (page === Pages.TEST || page === Pages.LOGIN) {
    return  (
      <div>
        <LoginPage handleSubmit={() => SubmitLogin(setPage)} handleRegister={() => toRegistration(setPage)}/>
      </div>
    
    );
    /*
    return (
    <div className="App">
      <button onClick={() => setPage(Pages.METRICS)}>Click To Update Page</button>
    </div>
    );
    */
  } else if (page === Pages.METRICS) {
    return (
      <div>
        <DriveWiseHeader handleLogout={() => handleLogout(setPage)}/>
        <MetricsPage handleLogsButton={() => toLogs(setPage)}/>
      </div>
    );
  } else if (page === Pages.LOGS) {
    return (
      <div>
        <DriveWiseHeader handleLogout={() => handleLogout(setPage)}/>
        <LogsPage handleMetricsButton={() => toMetrics(setPage)} user={user} toLogin={() => toLogin(setPage)}/>
      </div>
    );
  } else if (page === Pages.REGISTER) {
    return <RegistrationPage handleSubmit={() => Register(setPage)} toLogin={() => toLogin(setPage)}/>;    
    // return Page1(); // will add in when we implement
  } else {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
      </div>
    );
  }
}

export default App;
